/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SeverityConstants } from './SeverityConstants';
import {
    SeverityConstantsFromJSON,
    SeverityConstantsFromJSONTyped,
    SeverityConstantsToJSON,
} from './SeverityConstants';

/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {SeverityConstants}
     * @memberof Message
     */
    severity: SeverityConstants;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    text: string;
}

/**
 * Check if a given object implements the Message interface.
 */
export function instanceOfMessage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function MessageFromJSON(json: any): Message {
    return MessageFromJSONTyped(json, false);
}

export function MessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): Message {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'severity': SeverityConstantsFromJSON(json['severity']),
        'text': json['text'],
    };
}

export function MessageToJSON(value?: Message | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'severity': SeverityConstantsToJSON(value.severity),
        'text': value.text,
    };
}

